class CartCount extends window.BAO.CustomElement() {
    setupListeners () {
      super.setupListeners()

      this.onCartChanged = this.onCartChanged.bind(this)

      window.BAO.eventBus.addEventListener(
        window.BAO.EVENTS.PUSH_CART.CHANGED,
        this.onCartChanged,
      )
    }

    /**
     * @param {CustomEvent} e
     *
     * @returns {void}
     */
    async onCartChanged (e) {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();

        const totalItems = cart.items.reduce((total, item) => {
          const isMonogram = item.title.toLowerCase().includes('monogramming') && item.product_type === 'PPLR_HIDDEN_PRODUCT'

          // If item is monogramming, count as 1, otherwise use its actual quantity
          return total + (isMonogram ? 1 : item.quantity);
        }, 0);

        this.textContent = totalItems;
        this.setAttribute('aria-hidden', totalItems === 0);

      } catch (error) {
        console.error('Error fetching cart:', error);
      }
    }

    /**
     * @param {string} html
     *
     * @returns {string}
     */
    getCount(html) {
      const DOM = window.BAO.sectionRenderer.convertToDOM(html);
      const countElement = DOM.querySelector('#push-cart-count');

      if (countElement) {
        return countElement.textContent;
      } else {
        console.error('Element with ID #push-cart-count not found.');
        return null; // or return a default value like '0'
      }
    }
  }

  if (!customElements.get('cart-count')) {
    customElements.define('cart-count', CartCount)
  }
